import { Link } from "react-router-dom";
import { Button, buttonClasses, Card, MicroLabel } from "@bht/ui";

/**
 * Home-screen footer card: option to take a full-length practice test.
 *
 * Sits at the bottom of Home as a quiet, deemphasized entry. The daily
 * loop (Hidden Test, drills) is the headline; the practice test is for
 * the days a learner wants a longer block.
 */
export function PracticeTestCard() {
  return (
    <Card tight>
      <div className="app-stack" style={{ gap: "var(--sp-2)" }}>
        <MicroLabel color="accent">Full-length practice test</MicroLabel>
        <p style={{ color: "var(--fg-2)", fontSize: "var(--t-small)", lineHeight: 1.55, margin: 0 }}>
          98 questions across Reading & Writing and Math, about two
          hours. You get a 200 to 800 score per section and the skills
          that tripped you up.
        </p>
        <Link to="/app/practice-test" style={{ alignSelf: "stretch" }} className={buttonClasses({ variant: "ghost", full: true })}>Take a practice test</Link>
      </div>
    </Card>
  );
}
